module.exports = __webpack_public_path__ + "img/icons-5.e20a51ed.png";